import { render, staticRenderFns } from "./PurchaseProduct.vue?vue&type=template&id=6c1f676c&scoped=true&"
import script from "./PurchaseProduct.vue?vue&type=script&lang=js&"
export * from "./PurchaseProduct.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProduct.vue?vue&type=style&index=0&id=6c1f676c&prod&scoped=true&lang=css&"
import style1 from "./PurchaseProduct.vue?vue&type=style&index=1&id=6c1f676c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f676c",
  null
  
)

export default component.exports